import { schema } from 'normalizr';

export const offer = new schema.Entity('offers');
export const offers = [offer];

offer.define({
  creditBands: require('shared/store/modules/creditBands/schemas').creditBands
});
